// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"styles_textareaWrapper__pbh7G","textarea":"styles_textarea__2oFfF","submitButton":"styles_submitButton__2FBFB"};